// **************************
// *** AgendamentosConcluidos concluidos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 17/06/24 | 15:02h
// *** 4/7/24 | 09h39 → acrescentado o token criptografado
// *** 4/10/24 | 13h13 → acrescentado colaboradores
// *** 14/11/24 | 13h54 → corrigido e melhorado a paginação em ambos os tipos de atendimento (tipoAtendimento = 0 ou 1)
// *** 01/12/24 | 21h32 → acrescentado o botão "opções" 
// **************************



import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import { Dock } from 'react-dock'; // acrescentado para apresentar o menu "opções" de baixo pra cima 15/11/24w
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Menu from "../../Components/Menu/p_menu.jsx";
import CardAgendamentos from '../../Components/Agendamentos/p_agendamentos.jsx';
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";
import handleApiError from '../../../../Services/apiErrorHandler.js';

import './p_agendamentos.css';
import { AutoLogout } from "../../../../Services/autologout.js";
import { p_getUserData } from "../../../../Services/p_userutils.js";
import CardAgendamentoOpcoes from "../../Components/Agendamentos/p_cardagendamentoopcoes.jsx";

function AgendamentosConcluidos() {
    // verifica se os tokens estavam corretos
    const tokenASW = localStorage.getItem("tokenasw");
    const tokenlg = localStorage.getItem("tokenlg");
    // verifica se os tokens estavam corretos
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    // se ajusta de acordo com o sistema (mobile, tablet, nb, pc, etc)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    const initialUserData = p_getUserData();
    const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores
    const [id_usuario, setId_usuario] = useState(initialUserData.userId); // id_usuario logado 23/9/24w
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.TAMANHO_PAGINA); // id_usuario logado 23/9/24w

    const [nenhumAgendamentoEncontrado, setNenhumAgendamentoEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);

    const [colaboradores, setColaboradores] = useState([]);
    const [colaborador, setColaborador] = useState(null);
    const [selectedColaborador, setSelectedColaborador] = useState(null);
    const [colaboradorAgendamentos, setColaboradorAgendamentos] = useState([]);
    const [nenhumColaboradorEncontrado, setNenhumColaboradorEncontrado] = useState(false);
    const [dockOpen, setDockOpen] = useState(false); // Gerencia o estado do Dock
    // const [dockOperation, setDockOperation] = useState(""); // Gerencia a operação do Dock
    const openDock = () => setDockOpen(true);
    const closeDock = () => setDockOpen(false); // fechar o dock de dentro do componente p-cardservico.jsx
    const [selectedAgendamento, setSelectedAgendamento] = useState([]);

    useEffect(() => {
        setHasMore(true);
        const fetchAgendamentos = async () => {
          if (tipoAtendimento === 0) {
            // Chamada para agendamentos do tipo "Meus Agendamentos"
            await fetchAgendamentosAbertos(pagina);
          } else if (tipoAtendimento === 1 && colaborador) {
            // Chamada para agendamentos do colaborador selecionado
            await fetchAgendamentosPorColaborador(colaborador, pagina);
          }
        };
      
        fetchAgendamentos();
    }, [pagina, tipoAtendimento, colaborador]);

    // tipoAtendimento === 0 (busca agendamentos somente se não tiver colaboradores) 23/9/24w
    const fetchAgendamentosAbertos = async (pagina) => {
        setLoading(true);
        const url = `reserva/listarWeb?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=2&id_status2=5&token=${tokenASW}`;
        try {
            const response = await apiaxios.get(url);
            // setLoading(false);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento concluído, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoEncontrado(false);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            setLoading(false);
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    // tipoAtendimento === 1 (busca agendamentos dos colaboradores) 23/9/24w
    const fetchAgendamentosPorColaborador = async (id_colaborador, pagina) => {
        // console.log('atualizando após exclusão / id_col , pag', id_colaborador, pagina);
        setLoading(true);
        // setAgendamentos([]);
        const url = `reserva/listarColaboradorWeb?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=2&id_status2=5&token=${tokenASW}&id_colaborador=${id_colaborador}`;
        try {
            const response = await apiaxios.get(url);
            // setLoading(false);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento concluído, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoEncontrado(false);
                    // console.log(`response data ao trocar colaborador: ${id_colaborador} `, response.data);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };
    
    const handleAvaliar = async (agendamento) => {
        const { ID_RESERVA, ID_EMPRESA, NOME, DESCRICAO } = agendamento;
        
        // Primeira requisição para buscar as avaliações do prestador
        try {
            const response = await apiaxios.get(`/reserva/avaliacaoWeb?id_usuario=${ID_EMPRESA}&tipo_avaliacao=P`);
            const { avaliacao, quantidade, retorno } = response.data;
    
            if (retorno !== 'OK') {
                Swal.fire('Erro', retorno, 'error');
                return;
            }
    
            let selectedRating = 0;
    
            MySwal.fire({
                title: 'Qual nota você daria para este Prestador de Serviços?',
                html: `
                    <p>${NOME} (ID Reserva: ${ID_RESERVA})</p>
                    <p>${DESCRICAO}</p>
                    <div id="rating" style="display: flex; justify-content: center;">
                        ${[1, 2, 3, 4, 5].map(i => `<i class="fa fa-star" data-value="${i}" style="cursor: pointer; font-size: 2em; margin: 0 5px;"></i>`).join('')}
                    </div>
                    <p>${quantidade > 0 ? `${quantidade} avaliação${quantidade > 1 ? 's' : ''}` : 'Prestador ainda não foi avaliado. Você é o primeiro cliente a fazê-lo!'}</p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Enviar Avaliação',
                cancelButtonText: 'Voltar',
                didOpen: () => {
                    const stars = MySwal.getPopup().querySelectorAll('.fa-star');
                    stars.forEach(star => {
                        star.addEventListener('click', (e) => {
                            selectedRating = parseInt(e.target.getAttribute('data-value'));
                            stars.forEach(s => s.style.color = s.getAttribute('data-value') <= selectedRating ? 'gold' : 'gray');
                        });
                    });
                },
                preConfirm: () => {
                    if (selectedRating === 0) {
                        Swal.showValidationMessage('Por favor, selecione uma nota antes de enviar.');
                        return false;
                    }
                    return selectedRating;
                }
            }).then(result => {
                if (result.isConfirmed) {
                    // Segunda requisição para enviar a avaliação
                    const id_usuario = JSON.parse(localStorage.getItem("tokenacw")).id_usuario;
    
                    apiaxios.get(`/reserva/avaliarWeb?id_usuario=${id_usuario}&id_reserva=${ID_RESERVA}&tipo_avaliacao=C&avaliacao=${result.value}`)
                        .then(response => {
                            if (response.status === 200 && response.data.retorno === "OK") {
                                Swal.fire('Sucesso', 'Avaliação enviada com sucesso!', 'success');
                                // Atualize a interface conforme necessário
                            } else {
                                Swal.fire('Erro', response.data.retorno || 'Erro ao enviar avaliação', 'error');
                            }
                        })
                        .catch(error => {
                            Swal.fire('Erro', 'Erro ao enviar avaliação: ' + error, 'error');
                        });
                }
            });
        } catch (error) {
            Swal.fire('Erro', 'Erro ao buscar avaliações: ' + error, 'error');
        }
    };
    
    const handleOpcoes = (agendamento) => {
        setTimeout(() => {
            setSelectedAgendamento(agendamento);
            setDockOpen(true); // Abre o Dock
        }, 100);
    };

    useEffect(() => {
        const loadColaboradores = async () => {
            // console.log('dentro de loadColaboradores');
            if (id_usuario) {
                try {
                    // console.log('dentro de try');
                    const empresaColaboradores = await fetchColaboradores(id_usuario);
                    setColaboradores(empresaColaboradores);
                } catch (error) {
                    // console.log('dentro de catch');
                    console.error('Erro ao buscar colaboradores:', error);
                }
            }
        };

        loadColaboradores();

    }, [id_usuario]);
    
    const fetchColaboradores = async (id_empresa) => {
        try {
            setLoading(true);
//             const colaboradoresResponse = await apiaxios.get(`/empresa/colaboradorWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            const colaboradoresResponse = await apiaxios.get(`/colaborador/listarWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            if (colaboradoresResponse.status === 200 && colaboradoresResponse.data.length > 0) {
                return colaboradoresResponse.data;
            } else {
                setNenhumColaboradorEncontrado(true);
                return [];
            }
        } catch (error) {
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };




    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="agendamentosconcluidos" />
                        </div>
                        <div className="col py-2 me-3">
                            { tipoAtendimento === 0 ? (  
                                <div className="container-fluid">
                                    <h1 className="text-center">Agendamentos Concluídos</h1>
                                    <div className="row">
                                        {loading && (
                                            <div className="loading-spinner-container">
                                                <Oval color="#00BFFF" height={80} width={80} />
                                            </div>
                                        )}
                                        {/* {nenhumAgendamentoConcluidoEncontrado ? ( */}
                                        {nenhumAgendamentoEncontrado ? (
                                            <div className="alert alert-danger mt-10" role="alert">
                                                Nenhum "Agendamento Concluído" disponível neste momento...
                                            </div>
                                        ) : (
                                            <div className="box-agendamentos">
                                                <div className="table-responsive">  {/* ← ADICIONE AQUI */}
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Id</th>
                                                            <th>Descrição</th>
                                                            <th>Nome Cliente</th>
                                                            <th>Fone Cliente</th>
                                                            <th>Data</th>
                                                            <th>Hora</th>
                                                            <th>Valor</th>
                                                            <th>Desconto</th>
                                                            <th>Valor Total</th>
                                                            <th>Obs</th>
                                                            <th className="text-right">Status</th>
                                                            <th className="text-right">Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* {agendamentos.filter(agendamento => agendamento.ID_STATUS === 5).map(agendamento => ( */}
                                                        {agendamentos.map((agendamento, index) => (
                                                            <CardAgendamentos
                                                                // key={agendamento.ID_RESERVA}
                                                                key={`${agendamento.ID_RESERVA}-${index}`}
                                                                agendamento={{
                                                                    agendamento_id: agendamento.ID_RESERVA,
                                                                    agendamento_descricao: agendamento.DESCRICAO,
                                                                    agendamento_nome: agendamento.NOME,
                                                                    agendamento_data: agendamento.DATA_RESERVA,
                                                                    agendamento_hora: agendamento.HORA,
                                                                    agendamento_vr: agendamento.VALOR,
                                                                    agendamento_desc: agendamento.DESCONTO || 'R$ 0,00',
                                                                    agendamento_vrtot: agendamento.VALORTOTAL || 'Vr Tot indisponível',
                                                                    agendamento_endereco: `${agendamento.ENDERECO} ${agendamento.BAIRRO} - ${agendamento.CIDADE}`,
                                                                    agendamento_fone: agendamento.FONE,
                                                                    agendamento_obs: agendamento.AA_DESCRICAO || 'Obs indisp',
                                                                    agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO}`
                                                                }}
                                                                showOpcoes={true}
                                                                showExcluir={false}
                                                                showAvaliar={agendamento.AVAL_PRESTADOR_PELO_CLIENTE < 1 && agendamento.ID_STATUS === 3} // Aqui ajustamos a propriedade showAvaliar
                                                                showMotivo={false}
                                                                showMudarStatus={false}
                                                                handleAvaliar={() => handleAvaliar(agendamento)}
                                                                handleOpcoes={handleOpcoes}
                                                            />
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            </div>
                                        )}
                                    </div>
                                    {hasMore && (
                                        <div className="load-more">
                                            <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="form-group">
                                    <h1 className="text-center">Agendamentos Concluídos por Colaborador</h1>
                                    <hr />
                                    <label htmlFor="colaborador">Selecione o Colaborador:</label>
                                    <select className="form-control" id="colaborador" 
                                        onChange={e => {
                                            const selectedColaborador = e.target.value;
                                            setColaborador(selectedColaborador); 
                                            setPagina(1); // Reinicia a página para o valor inicial
                                            setAgendamentos([]);
                                            // atualizarAgendamentosColaborador(selectedColaborador, pagina);
                                            }} 
                                        value={colaborador || ''}
                                    >
                                        <option value="" disabled>Selecione...</option>
                                        {colaboradores.map(colab => (
                                            <option key={colab.COL_ID} value={colab.COL_ID}>
                                                {colab.COL_NOME}
                                            </option>
                                        ))}
                                    </select>

                                    <div className="row">
                                        {loading && (
                                            <div className="loading-spinner-container">
                                                <Oval color="#00BFFF" height={80} width={80} />
                                            </div>
                                        )}
                                        {nenhumAgendamentoEncontrado ? (
                                            <div className="alert alert-danger mt-10" role="alert">
                                                Nenhum "Agendamento Concluído" disponível neste momento...
                                            </div>
                                        ) : (
                                            <div className="box-agendamentos">
                                                <div className="table-responsive">  {/* ← ADICIONE AQUI */}
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Id</th>
                                                            <th>Descrição</th>
                                                            <th>Nome Cliente</th>
                                                            <th>Fone Cliente</th>
                                                            <th>Data</th>
                                                            <th>Hora</th>
                                                            <th>Valor</th>
                                                            <th>Desconto</th>
                                                            <th>Valor Total</th>
                                                            <th>Nome Colaborador</th>
                                                            <th>Obs</th>
                                                            <th className="text-right">Status</th>
                                                            <th className="text-right">Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {agendamentos.map((agendamento, index) => (
                                                            <CardAgendamentos
                                                                key={`${agendamento.ID_RESERVA}-${index}`}
                                                                agendamento={{
                                                                    agendamento_id: agendamento.ID_RESERVA,
                                                                    agendamento_descricao: agendamento.DESCRICAO || 'Descrição indisponível',
                                                                    agendamento_nome: agendamento.AA_CLIENTE_NOME || 'Nome indisponível',
                                                                    agendamento_fone: agendamento.AA_CLIENTE_FONE || 'Telefone indisponível',
                                                                    agendamento_data: agendamento.DATA_RESERVA || 'Data indisponível',
                                                                    agendamento_hora: agendamento.HORA || 'Hora indisponível',
                                                                    agendamento_vr: agendamento.VALOR || 'Vr indisponível',
                                                                    agendamento_desc: agendamento.DESCONTO || 'R$ 0,00',
                                                                    agendamento_vrtot: agendamento.VALORTOTAL || 'Vr Tot indisponível',
                                                                    agendamento_nome_colaborador: agendamento.COL_NOME || 'Colaborador indisponível',
                                                                    agendamento_obs: agendamento.AA_DESCRICAO || 'Obs indisp',
                                                                    agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO || 'Status indisponível'}`
                                                                }}
                                                                showOpcoes={true}
                                                                showExcluir={false}
                                                                showAvaliar={false}
                                                                showMotivo={false}
                                                                showMudarStatus={false}
                                                                tipoAtendimento={tipoAtendimento}
                                                                handleOpcoes={handleOpcoes}
                                                            />
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            </div>
                                        )}
                                    </div>
                                    {hasMore && (
                                        <div className="load-more">
                                            {/* <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button> */}
                                            <button onClick={() => setPagina((prevPagina) => prevPagina + 1)}>
                                                Carregar mais
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}                                
                        </div>
                    </div>
                </div>
            </div>
                        {/* Dock para as opções do botão "opções" que subsitituiu o botão "excluir" */}
                        <Dock 
                position="bottom" 
                isVisible={dockOpen} 
                onVisibleChange={(visible) => setDockOpen(visible)} 
                fluid={true} 
                size={isMobile ? 0.8 : 0.7} // tamanho da tela em fração de %
            >
                <CardAgendamentoOpcoes id_usuario={id_usuario} tipoAtendimento={tipoAtendimento} agendamento={selectedAgendamento} closeDock={closeDock} paginaAgendamento='p_concluidos'/>
            </Dock>
            <Footer />
        </>
    );
}

export default AgendamentosConcluidos;